import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'

import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import CookieConsent from './components/CookieConsent'
import { ThemeProvider } from './contexts/ThemeContext'

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'))
const AuthPage = lazy(() => import('./pages/AuthPage'))
const DashboardPage = lazy(() => import('./pages/DashboardPage'))
const SearchPage = lazy(() => import('./pages/SearchPage'))
const ProfilePage = lazy(() => import('./pages/ProfilePage'))
const MessagesPage = lazy(() => import('./pages/MessagesPage'))
const SuggestionsPage = lazy(() => import('./pages/SuggestionsPage'))
const HowItWorksPage = lazy(() => import('./pages/HowItWorksPage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))
const CreateAnimalPage = lazy(() => import('./pages/CreateAnimalPage'))
const CreateServicePage = lazy(() => import('./pages/CreateServicePage'))
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'))
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage'))
const AdminPage = lazy(() => import('./pages/AdminPage'))

import { useAuthStore } from './stores/authStore'

function App() {
  const { isAuthenticated, user } = useAuthStore()

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <Header />

        <main className="flex-1">
          <Suspense fallback={
            <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 dark:from-gray-800 dark:via-gray-700 dark:to-gray-600 flex items-center justify-center">
              <div className="flex flex-col items-center space-y-4">
                <div className="w-12 h-12 border-4 border-orange-500 dark:border-orange-400 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-600 dark:text-gray-300 text-lg">Loading...</p>
              </div>
            </div>
          }>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/suggestions" element={<SuggestionsPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
            
            {/* Protected routes */}
            {isAuthenticated && user && (
              <>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/dashboard/animals/new" element={<CreateAnimalPage />} />
                  <Route path="/dashboard/services/new" element={<CreateServicePage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/messages" element={<MessagesPage />} />
                {user.is_admin && (
                    <Route path="/admin" element={<AdminPage />} />
                )}
              </>
            )}
            
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </main>

        <Footer />
        <CookieConsent />
      </div>
    </ThemeProvider>
  )
}

export default App